import React from 'react';
import classNames from 'classnames/bind';
import './userGridFilter.scss';
import {Search} from '../../../common/components/search/search';
import {DropdownMenu, DropdownMenuLink} from '../../../../../@elixir/router';
import {Button} from '../../../../../@elixir/components';
import {UserType} from '../enum';
import PropTypes from 'prop-types';

export class UserGridFilter extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.searchText = props.searchText;
        this.userType = props.userType;
    }

    onSearchChange (newSearch) {
        this.searchText = newSearch;
        this.broadcastChange();
    }

    onSelectUserType (userType) {
        if (!userType) {
            this.userType = [];
        }
        else if (this.userType.indexOf(userType) === -1) {
            this.userType.push(userType);
        }

        this.broadcastChange();
    }

    broadcastChange () {
        this.props.onFilterChange({
            searchText: this.searchText,
            userType: this.userType
        });
    }

    render () {
        const {
            searchText,
            userType
        } = this.props;

        const userTypeList = _.values(UserType);
        const userTypeFilterAllLabel = this.context.translator('userGridFilter.userTypeDropdown.all');

        return (
            <div className="userGridFilterComponent ">

                <Search searchText={searchText}
                        placeholder="userGridFilter.searchPlaceholder"
                        onValueChange={this.onSearchChange.bind(this)}/>

                <div className="secondaryComponentList">
                    <DropdownMenu
                        className="userTypeDropdown"
                        renderTrigger={(props, toggleMenu) => {
                            const {isOpen} = props;
                            const handleButtonClick = () => {
                                toggleMenu(!isOpen);
                            };

                            const onDeleteSelectedUserType = (userTypeId, event) => {
                                event.stopPropagation();

                                const userTypeIndex = this.userType.indexOf(userTypeId);
                                this.userType.splice(userTypeIndex, 1);
                                this.broadcastChange();
                            };

                            let selectedButtonList;

                            if (userType.length === 0) {
                                selectedButtonList = (
                                    <div className="selectedMenuItem">
                                        <div className="selectedMenuItemLabel">
                                            {userTypeFilterAllLabel}
                                        </div>
                                    </div>
                                );
                            }
                            else {
                                selectedButtonList = _.map(userType, (userTypeId) => {
                                    return <div className="selectedMenuItem"
                                                key={userTypeId}>
                                        <div className="selectedMenuItemLabel">
                                            {this.context.translator(`user.enum.userType.${userTypeId}`)}
                                        </div>
                                        <a onClick={onDeleteSelectedUserType.bind(this, userTypeId)}><i
                                            className="fas fa-times"/></a>
                                    </div>
                                })
                            }

                            return <div className="userTypeDropdownMenu">
                                <div className="userTypeDropdownMenuLabel">User Types:</div>
                                <Button className="userTypeDropdownMenuButton"
                                        name="userTypeDropdownButton"
                                        type="neutral"
                                        size="small"
                                        icon="fa-chevron-down"
                                        iconPosition="right"
                                        onClick={handleButtonClick.bind(this)}>

                                    {selectedButtonList}

                                </Button>
                            </div>;
                        }}
                        dropUp={false}
                        alignRight={true}
                        showCaret={false}>

                        <DropdownMenuLink className="dropdownMenuItem"
                                          key="empty">
                            <span>{this.context.translator('userGridFilter.userTypeDropdown.pleaseSelectLabel')}</span>
                        </DropdownMenuLink>

                        {_.map(userTypeList, (userTypeId) => {
                            const userTypeLabel = this.context.translator(`user.enum.userType.${userTypeId}`);
                            return <DropdownMenuLink key={userTypeId}
                                                     className={classNames('dropdownMenuItem', {'selected': userType.indexOf(userTypeId) !== -1})}
                                                     onClick={this.onSelectUserType.bind(this, userTypeId)}>

                                <i className="fas fa-check checkmark"/>
                                <span>{userTypeLabel}</span>

                            </DropdownMenuLink>;
                        })}

                        <DropdownMenuLink
                            className={classNames('dropdownMenuItem', 'allMenuItem', {'selected': userType.length === 0})}
                            onClick={this.onSelectUserType.bind(this, null)}>
                            <i className="fas fa-check checkmark"/>
                            <span>{this.context.translator('userGridFilter.userTypeDropdown.all')}</span>
                        </DropdownMenuLink>

                    </DropdownMenu>

                    <div className="refreshListContainer">
                        <Button className="refreshListButton"
                                name="refreshListButton"
                                type="neutral"
                                size="small"
                                icon="fa-redo-alt"
                                onClick={() => this.props.onRefresh()}>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

UserGridFilter.propTypes = {
    searchText: PropTypes.string,
    userType: PropTypes.array,
    onFilterChange: PropTypes.func,
    onRefresh: PropTypes.func
};
